import { render, staticRenderFns } from "./Account1CRUD.vue?vue&type=template&id=46dcd066"
import script from "./Account1CRUD.vue?vue&type=script&lang=js"
export * from "./Account1CRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports